import React from 'react';
import PropTypes from 'prop-types';
import '../../styles/custom-myles-styles.scss';

const CircleLogo = ({ url, name }) => {
    const rhFirstLetter = name.charAt(0);
    const hasUrl = !!url;
    return (
        <div className="rhImageContainer">
            {hasUrl ? (
                <img src={url} className="rhImage" alt="" />
            ) : (
                <div className="rhInitial">{rhFirstLetter}</div>
            )}
        </div>
    );
};

CircleLogo.propTypes = {
    url: PropTypes.string,
    name: PropTypes.string,
};

export default CircleLogo;
